import { ChevronDown } from 'lucide-react';
import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { AnimatedText, AnimatedTitle } from "@/components/ui/AnimatedText";
import { useSEO } from "@/utils/useSEO";

const galleryCategories = ["All", "Villa", "Pool", "Wellness", "Dining"];

const galleryItems = [
  {
    "id": 1,
    "src": "/media/rooms/private-pool-villa/private-pool-villa (1).webp",
    "category": "Villa",
    "title": "private pool villa (1).webp"
  },
  {
    "id": 2,
    "src": "/media/rooms/private-pool-villa/private-pool-villa (2).webp",
    "category": "Villa",
    "title": "private pool villa (2).webp"
  },
  {
    "id": 3,
    "src": "/media/rooms/deluxe-bungalow/deluxe-bungalow (1).webp",
    "category": "Villa",
    "title": "deluxe bungalow (1).webp"
  },
  {
    "id": 4,
    "src": "/media/rooms/deluxe-bungalow/deluxe-bungalow (2).webp",
    "category": "Villa",
    "title": "deluxe bungalow (2).webp"
  },
  {
    "id": 5,
    "src": "/media/rooms/deluxe-bungalow/deluxe-bungalow (3).webp",
    "category": "Villa",
    "title": "deluxe bungalow (3).webp"
  },
  {
    "id": 6,
    "src": "/media/rooms/deluxe-bungalow/deluxe-bungalow (4).webp",
    "category": "Villa",
    "title": "deluxe bungalow (4).webp"
  },
  {
    "id": 7,
    "src": "/media/rooms/deluxe-bungalow/deluxe-bungalow (5).webp",
    "category": "Villa",
    "title": "deluxe bungalow (5).webp"
  },
  {
    "id": 8,
    "src": "/media/rooms/suite-room/suite-room (1).webp",
    "category": "Villa",
    "title": "suite room (1).webp"
  },
  {
    "id": 9,
    "src": "/media/rooms/suite-room/suite-room (2).webp",
    "category": "Villa",
    "title": "suite room (2).webp"
  },
  {
    "id": 10,
    "src": "/media/rooms/suite-room/suite-room (3).webp",
    "category": "Villa",
    "title": "suite room (3).webp"
  },
  {
    "id": 11,
    "src": "/media/rooms/suite-room/suite-room (4).webp",
    "category": "Villa",
    "title": "suite room (4).webp"
  },
  {
    "id": 12,
    "src": "/media/rooms/suite-room/suite-room (5).webp",
    "category": "Villa",
    "title": "suite room (5).webp"
  },
  {
    "id": 13,
    "src": "/media/rooms/suite-room/suite-room (6).webp",
    "category": "Villa",
    "title": "suite room (6).webp"
  },
  {
    "id": 14,
    "src": "/media/rooms/suite-room/suite-room (7).webp",
    "category": "Villa",
    "title": "suite room (7).webp"
  },
  {
    "id": 15,
    "src": "/media/rooms/private-pool-villa/private-pool-villa-night-scene-1.webp",
    "category": "Villa",
    "title": "private pool villa night scene 1.png"
  },
  {
    "id": 16,
    "src": "/media/rooms/private-pool-villa/private-pool-villa-night-scene-2.webp",
    "category": "Villa",
    "title": "private pool villa night scene 2.png"
  },
  {
    "id": 17,
    "src": "/media/rooms/private-pool-villa/private-pool-villa-night-scene-3.webp",
    "category": "Villa",
    "title": "private pool villa night scene 3.png"
  },
  {
    "id": 18,
    "src": "/media/spa (1).webp",
    "category": "Wellness",
    "title": "spa (1)"
  },
  {
    "id": 19,
    "src": "/media/spa (2).webp",
    "category": "Wellness",
    "title": "spa (2)"
  },
  {
    "id": 20,
    "src": "/media/spa (3).webp",
    "category": "Wellness",
    "title": "spa (3)"
  },
  {
    "id": 21,
    "src": "/media/spa-patal-sunrise.webp",
    "category": "Wellness",
    "title": "spa patal sunrise"
  },
  {
    "id": 22,
    "src": "/media/spa-patal.webp",
    "category": "Wellness",
    "title": "spa patal"
  },
  {
    "id": 23,
    "src": "/media/patal-spa.webp",
    "category": "Wellness",
    "title": "patal spa"
  },
  {
    "id": 24,
    "src": "/media/patal-spa-view.webp",
    "category": "Wellness",
    "title": "patal spa view"
  },
  {
    "id": 25,
    "src": "/media/floating-breakfast-infinity-pool.webp",
    "category": "Pool",
    "title": "floating breakfast infinity pool"
  },
  {
    "id": 26,
    "src": "/media/infinity-pool-sunrise.webp",
    "category": "Pool",
    "title": "infinity pool sunrise"
  },
  {
    "id": 27,
    "src": "/media/pool-private-villa.webp",
    "category": "Pool",
    "title": "pool private villa"
  },
  {
    "id": 28,
    "src": "/media/patal-kikian-restaurant (1).webp",
    "category": "Dining",
    "title": "patal kikian restaurant (1)"
  },
  {
    "id": 29,
    "src": "/media/patal-kikian-restaurant (2).webp",
    "category": "Dining",
    "title": "patal kikian restaurant (2)"
  },
  {
    "id": 30,
    "src": "/media/patal-restaurant-1.webp",
    "category": "Dining",
    "title": "patal restaurant 1"
  },
  {
    "id": 31,
    "src": "/media/patal-restaurant-outdoor.webp",
    "category": "Dining",
    "title": "patal restaurant outdoor"
  }
];

export default function Gallery() {
  useSEO(
    "Photo Gallery",
    "Browse our photo gallery and be inspired by the breathtaking beauty of Patal Kikian Villas Sidemen. From sweeping Mount Agung panoramas and emerald rice terraces to luxury villa interiors, spa, and infinity pool views."
  );
  const [activeCategory, setActiveCategory] = useState("All");
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  const filteredItems = activeCategory === "All" 
    ? galleryItems 
    : galleryItems.filter(item => item.category === activeCategory);

  // Keyboard navigation for lightbox
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (lightboxIndex === null) return;
      if (e.key === "Escape") {
        setLightboxIndex(null);
      } else if (e.key === "ArrowRight") {
        setLightboxIndex((prev) => (prev !== null && prev < filteredItems.length - 1 ? prev + 1 : 0));
      } else if (e.key === "ArrowLeft") {
        setLightboxIndex((prev) => (prev !== null && prev > 0 ? prev - 1 : filteredItems.length - 1));
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [lightboxIndex, filteredItems.length]);

  const scrollToGallery = () => {
    const element = document.getElementById('gallery-section');
    if (element) {
      window.scrollTo({
        top: element.getBoundingClientRect().top + window.scrollY - 80,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="min-h-[100dvh] bg-background text-white selection:bg-gold/30 selection:text-gold font-sans flex flex-col">
      {/* Hero Section */}
      <section className="relative min-h-[100dvh] w-full flex items-center justify-center">
        <div className="absolute inset-0">
          <img
            src="/media/patal-kikian-hero-banner.webp"
            alt="Patal Kikian Gallery"
            className="w-full h-full object-cover opacity-85"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background via-background/30 to-transparent" />
        </div>
        
        <div className="relative z-10 text-center px-4 mt-20">
          <AnimatedText delay={0.1}>
            <span className="text-gold uppercase tracking-[0.2em] text-xs font-semibold mb-4 block">Visual Journey</span>
          </AnimatedText>
          <AnimatedTitle title="The Gallery" className="text-4xl md:text-5xl lg:text-6xl font-luxury mb-6 text-shadow-lg leading-tight" />
          <AnimatedText delay={0.3}>
            <p className="text-white/80 max-w-3xl mx-auto text-lg leading-relaxed">
              Explore the tranquil environments, luxurious villa setups, sparkling swimming pools, relaxing wellness spa spaces, and gourmet culinary experiences.
            </p>
          </AnimatedText>
        </div>

        {/* Scroll Down Button */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20">
          <button 
            onClick={scrollToGallery}
            className="text-white/70 hover:text-white transition-colors duration-300 flex flex-col items-center gap-2 cursor-pointer"
            aria-label="Scroll to gallery"
          >
            <span className="uppercase tracking-[0.2em] text-[10px]">View Gallery</span>
            <ChevronDown size={24} className="animate-bounce" />
          </button>
        </div>
      </section>

      {/* Gallery Grid */}
      <section id="gallery-section" className="pb-32 pt-16 bg-background relative z-20 flex-grow">
        <div className="container mx-auto px-6">
          {/* Category Filter Tabs */}
          <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 max-w-3xl mx-auto mb-12">
            {galleryCategories.map((category) => (
              <button
                key={category}
                onClick={() => {
                  setActiveCategory(category);
                  setLightboxIndex(null); // Close lightbox or reset index if active
                }}
                className={`px-6 py-2.5 rounded-full border text-sm uppercase tracking-wider transition-all duration-300 cursor-pointer ${
                  activeCategory === category
                    ? "bg-gold border-gold text-black font-semibold shadow-lg shadow-gold/20"
                    : "border-white/10 text-gray-400 hover:border-gold hover:text-gold"
                }`}
              >
                {category}
              </button>
            ))}
          </div>

          <motion.div 
            layout 
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
          >
            <AnimatePresence mode="popLayout">
              {filteredItems.map((item, idx) => (
                <motion.div
                  key={item.id}
                  layout
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.9 }}
                  transition={{ duration: 0.4 }}
                  onClick={() => setLightboxIndex(idx)}
                  className="group relative overflow-hidden rounded-xl bg-black/40 border border-white/5 aspect-[4/3] cursor-pointer"
                >
                  <img
                    src={item.src}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
                    <span className="text-gold text-xs uppercase tracking-wider font-semibold mb-1">
                      {item.category}
                    </span>
                    <h3 className="text-white text-lg font-serif">
                      {item.title}
                    </h3>
                  </div>
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>
        </div>
      </section>

      {/* Lightbox / Modal */}
      <AnimatePresence>
        {lightboxIndex !== null && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[99999] bg-black/95 backdrop-blur-md flex items-center justify-center p-4 select-none"
            onClick={() => setLightboxIndex(null)}
          >
            {/* Close button */}
            <button
              onClick={() => setLightboxIndex(null)}
              className="absolute top-6 right-6 text-white/70 hover:text-white cursor-pointer z-10 p-2"
              aria-label="Close Lightbox"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            {/* Left navigation arrow */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                setLightboxIndex((prev) => (prev !== null && prev > 0 ? prev - 1 : filteredItems.length - 1));
              }}
              className="absolute left-6 text-white/50 hover:text-white cursor-pointer bg-white/5 hover:bg-white/10 p-3 rounded-full transition-colors z-10"
              aria-label="Previous image"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>

            {/* Main image and title container */}
            <div 
              className="relative max-w-5xl max-h-[80vh] flex flex-col items-center"
              onClick={(e) => e.stopPropagation()}
            >
              <motion.img
                key={filteredItems[lightboxIndex].src}
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.3 }}
                src={filteredItems[lightboxIndex].src}
                alt={filteredItems[lightboxIndex].title}
                className="max-w-full max-h-[70vh] object-contain rounded-lg shadow-2xl"
              />
              
              <div className="text-center mt-4">
                <span className="text-gold text-xs uppercase tracking-widest font-semibold block mb-1">
                  {filteredItems[lightboxIndex].category}
                </span>
                <h4 className="text-white text-xl font-serif">
                  {filteredItems[lightboxIndex].title}
                </h4>
                <p className="text-gray-500 text-sm mt-1">
                  {lightboxIndex + 1} / {filteredItems.length}
                </p>
              </div>
            </div>

            {/* Right navigation arrow */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                setLightboxIndex((prev) => (prev !== null && prev < filteredItems.length - 1 ? prev + 1 : 0));
              }}
              className="absolute right-6 text-white/50 hover:text-white cursor-pointer bg-white/5 hover:bg-white/10 p-3 rounded-full transition-colors z-10"
              aria-label="Next image"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
